import type { Theme, ThemeOptions } from '@mui/material/styles';

/**
 * MUI `Typography` overrides for design-system variants (`h1`–`h4`, `body1` for `body`).
 */
export function typographyThemeComponents(_theme: Theme): ThemeOptions['components'] {
  return {
    MuiTypography: {
      styleOverrides: {
        root: {
          '&.SmTypography-root': {
            textTransform: 'none'
          }
        },
        h1: {
          fontWeight: 400,
          fontSize: '36px'
        },
        h2: {
          fontWeight: 700,
          fontSize: '20.8px'
        },
        h3: {
          fontWeight: 700,
          fontSize: '20px'
        },
        h4: {
          fontWeight: 600,
          fontSize: '12.8px'
        },
        body1: {
          fontWeight: 400,
          fontSize: '14px'
        }
      }
    }
  };
}
